/**
 * Region configuration for OptiDev Cloud (Supabase)
 * Used by ActivationPanel and RemixAppModal
 */

export interface RegionInfo {
  id: string;
  name: string;
  flag: string;
  recommended?: boolean;
  smartRegion?: 'Americas' | 'Europe' | 'APAC';
}

export const REGION_CONFIG: Record<string, RegionInfo> = {
  'us-east-2': { id: 'us-east-2', name: 'East US (Ohio)', flag: '🇺🇸', recommended: true, smartRegion: 'Americas' },
  'us-east-1': { id: 'us-east-1', name: 'East US (North Virginia)', flag: '🇺🇸' },
  'us-west-1': { id: 'us-west-1', name: 'West US (North California)', flag: '🇺🇸' },
  'us-west-2': { id: 'us-west-2', name: 'West US (Oregon)', flag: '🇺🇸' },
  'ca-central-1': { id: 'ca-central-1', name: 'Canada (Central)', flag: '🇨🇦' },
  'eu-central-1': { id: 'eu-central-1', name: 'Central Europe (Frankfurt)', flag: '🇩🇪', smartRegion: 'Europe' },
  'eu-west-1': { id: 'eu-west-1', name: 'West EU (Ireland)', flag: '🇮🇪' },
  'eu-west-2': { id: 'eu-west-2', name: 'West Europe (London)', flag: '🇬🇧' },
  'eu-west-3': { id: 'eu-west-3', name: 'Europe (Paris)', flag: '🇫🇷' },
  'eu-north-1': { id: 'eu-north-1', name: 'North Europe (Stockholm)', flag: '🇸🇪' },
  'ap-southeast-1': { id: 'ap-southeast-1', name: 'Southeast Asia (Singapore)', flag: '🇸🇬' },
  'ap-southeast-2': { id: 'ap-southeast-2', name: 'APAC (Sydney)', flag: '🇦🇺', smartRegion: 'APAC' },
  'ap-northeast-1': { id: 'ap-northeast-1', name: 'Asia Pacific (Tokyo)', flag: '🇯🇵' },
  'ap-northeast-2': { id: 'ap-northeast-2', name: 'Asia Pacific (Seoul)', flag: '🇰🇷' },
  'ap-south-1': { id: 'ap-south-1', name: 'Asia Pacific (Mumbai)', flag: '🇮🇳' },
  'sa-east-1': { id: 'sa-east-1', name: 'South America (São Paulo)', flag: '🇧🇷' },
};

export const DEFAULT_REGION = 'us-east-2';
